import { render, staticRenderFns } from "./usergroup-technical-assistance.vue?vue&type=template&id=1fd4a7e6&scoped=true"
import script from "./usergroup-technical-assistance.vue?vue&type=script&lang=js"
export * from "./usergroup-technical-assistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4a7e6",
  null
  
)

export default component.exports